// state
import logger from "~/utilities/logger";

export const state = {};

// getters
export const getters = {};

// mutations
export const mutations = {};

// actions
export const actions = {
  truncate({ commit }, payload)
  {
    if (payload.str != null && payload.n != null)
    {
      // logger.error("truncate", payload)
      return payload.str.length > payload.n
        ? payload.str.substr(0, payload.n - 1) + "..."
        : payload.str;
    }
  },

  dataNotValid({ commit }, payload)
  {
    logger.log("store.data not valid");
    let message = payload.msg != null ? payload.msg : "Data not valid";
    // Swal.fire({
    //   icon: "error",
    //   // title: i18n.t('error_alert_title'),
    //   title: "Error",
    //   text: message,
    //   reverseButtons: true,
    //   confirmButtonText: "OK",
    //   // cancelButtonText: i18n.t('cancel')
    // });
  },

  getRandomToken({ commit }, length)
  {
    if (length && length > 0)
    {
      return (rand() + rand() + rand() + rand()).substring(0, length);
    }

    return null;
  },
};

const rand = () => Math.random(0).toString(36).substring(2);

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
